import React from "react";
import "./Footer.css";
import { NavLink } from "react-router-dom";

const Footer = () => (
  <footer className="footer">
    <div className="footer__inner">
      <div className="footer__top">
        <div className="footer__brand">
          <p className="footer__tagline">
            Smart locker solutions for workplaces, schools, and events.
          </p>
        </div>

        <nav className="footer__nav">
          <div className="footer__nav-group">
            <h4>Solutions</h4>
            <ul>
              <li>
                <NavLink to="/about/features">Features</NavLink>
              </li>
              <li>
                <NavLink to="/about/services">Services</NavLink>
              </li>
              <li>
                <NavLink to="/about/projects">Projects</NavLink>
              </li>
            </ul>
          </div>
          <div className="footer__nav-group">
            <h4>Product</h4>
            <ul>
              <li>
                <NavLink to="/components">Components</NavLink>
              </li>
            </ul>
          </div>
          <div className="footer__nav-group">
            <h4>Contact</h4>
            <ul>
              <li>
                <a href="mailto:sales@qeeper-nordic.com">
                  sales@qeeper-nordic.com
                </a>
              </li>
              <li>
                <a href="tel:+37122042345">+371 22 042 345</a>
              </li>
              <li>
                <NavLink to="/contact">Contact form</NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </div>

      <div className="footer__bottom">
        <span>
          &copy; {new Date().getFullYear()} Qeeper Nordic. All rights reserved.
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
